<template>
  <div>
    <el-form
      ref="form"
      size="mini"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_search_isDefault') || '是否默认工厂'"
            ><br />
            <el-radio-group size="small" v-model="formData.isDefault">
              <el-radio label="Y">
                {{ this.$l('INDEX.YES') || '是' }}
              </el-radio>
              <el-radio label="N">
                {{ this.$l('INDEX.NO') || '否' }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_scm') || '工厂'"
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmPartners"
              :selectedLabel.sync="formData.scmName"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_ncNo') || 'NC产品编号'"
            prop="ncNo"
          >
            <el-input v-model="formData.ncNo" clearable maxlength="50">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_moq') || 'MOQ'"
            prop="ftyMoq"
          >
            <el-input-number
              v-model="formData.ftyMoq"
              :controls="false"
              :step="1"
              :min="0"
              :max="999999999"
              :precision="0"
              v-el-inputnumber-default0
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_ftyPrice') || '工厂单价(rmb)'"
            prop="ftyPrice"
          >
            <el-input-number
              v-model="formData.ftyPrice"
              :controls="false"
              :step="1"
              :min="0"
              :max="999999999999999"
              :precision="2"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_buyer') || '采购人员'"
            prop="buyerCode"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.buyerName"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_search_ftyLeadTime') || '生产周期(天)'"
            prop="ftyLeadTime"
          >
            <el-input-number
              v-model="formData.ftyLeadTime"
              :controls="false"
              :step="1"
              :min="0"
              :max="999999999"
              :precision="0"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    hxSkuCode: String,
    hxSkuFtyCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: { isDefault: 'N' },
      rules: {
        ftyPrice: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_ftyPrice') || '请输入工厂单价',
            trigger: ' blur',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.form_placeholder_scm') || '请选择工厂',
            trigger: ' blur',
          },
        ],
        buyerCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_buyer') || '请选择采购人员',
            trigger: ' blur',
          },
        ],
        ncNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_ncNo') || '请输入NC产品编号',
            trigger: ' blur',
          },
        ],
        ftyMoq: [
          {
            required: true, 
            message: this.$l('INDEX.form_placeholder_MOQ') || '请输入MOQ',
            trigger: ' blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.hxSkuFtyCode) return

      this.$api
        .ecomHxSkuFtyDetailApi({
          hxSkuFtyCode: this.hxSkuFtyCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      //清除前后空格
      if (this.formData.ncNo) {
        this.formData.ncNo = this.formData.ncNo.trim()
      }
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .ecomHxSkuFtySaveApi({
          hxSkuCode: this.hxSkuCode,
          ...this.formData,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('saveReload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },

    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
